import { createAction } from 'typesafe-actions';

import {
  GetOrdersPayload,
  GetPickToursInProgressPayload,
  SetPickToursPayload,
  GetRecallOrdersPayload,
  GetCompletedRecallOrdersPayload,
  GetCompletedEPOrdersPayload,
  SetOrdersPayload,
  RetryOrderPayload,
  SetHasManualOverstockOrderPayload,
  SetOrderStatusPayload,
  ResetPickTourPayload,
  SetPickTourWithErrorPayload,
} from './orders.types';

export const getOrders = createAction('GET_ORDERS')<GetOrdersPayload>();

export const getPickToursInProgress = createAction('GET_PICK_TOURS_IN_PROGRESS')<GetPickToursInProgressPayload>();

export const setPickToursInProgress = createAction('SET_PICK_TOURS_IN_PROGRESS')<SetPickToursPayload>();

export const resetActivePickTour = createAction('RESET_ACTIVE_PICK_TOUR')<ResetPickTourPayload>();

export const resetActivePickTourComplete = createAction('RESET_ACTIVE_PICK_TOUR_COMPLETE')<ResetPickTourPayload>();

export const getRecallOrders = createAction('GET_RECALL_ORDERS')<GetRecallOrdersPayload>();

export const getCompletedRecalls = createAction('GET_COMPLETED_RECALL_ORDERS')<GetCompletedRecallOrdersPayload>();

export const getCompletedEPOrders = createAction('GET_COMPLETED_EP_ORDERS')<GetCompletedEPOrdersPayload>();

export const setOrders = createAction('SET_ORDERS')<SetOrdersPayload>();

export const retryOrder = createAction('RETRY_ORDER')<RetryOrderPayload>();

export const clearSelected = createAction('CLEAR_SELECTED')<boolean>();

export const setHasManualOverstockOrder = createAction('SET_HAS_MANUAL_OVERSTOCK_ORDER')<
  SetHasManualOverstockOrderPayload
>();

export const setPickTourWithError = createAction('SET_CURRENT_ERROR_ORDER')<SetPickTourWithErrorPayload>();

export const setOrderStatus = createAction('SET_ORDER_STATUS')<SetOrderStatusPayload>();
